import { Box } from 'components/Box';
import { Portal } from 'components/Portal';
import { H3 } from 'components/Text/H3';
import { Modal } from 'modals/Modal';
import { space } from 'theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

type Props = {
  onClose: () => void;
};

export function SubscribedToSubsiteModal({ onClose }: Props) {
  return (
    <Portal>
      <Modal
        onClose={onClose}
        data-qa-id="subscribed-to-subsite-modal"
        maxWidth={751}
      >
        <Box textAlign="center" pt={space[4]}>
          <Box mb={20}>
            <img
              src={getStaticImageSrc('email-alert.svg')}
              alt={getText('Thanks for subscribing!')}
            />
          </Box>
          <H3 mb={0} mt={0}>
            {getText('Thanks for subscribing!')}
          </H3>

          <Box>
            <p>
              {getText(
                'Thanks for subscribing to our monthly newsletter, you will get expert tips and useful resources for your social-impact career, delivered right to your inbox!',
              )}
            </p>
          </Box>
        </Box>
      </Modal>
    </Portal>
  );
}
